import { createMemoryHistory, LocationDescriptor } from 'history';
import appendQuery from 'append-query';

import { ABSOLUTE_URL_RE } from 'common/regex';
// need this so that we can just reuse the createLocation logic for parsing string path to pathname + query
const fakeHistory = createMemoryHistory();

/**
 * Given a relative string URL, returns a Location object with pathname and search fields parsed.
 * @param  {String} path a relative url
 * @return {Location}      object with pathname and search fields parsed from input.
 */
export function parsePath(path?: LocationDescriptor) {
  // not sure why this isn't just exposed in general...
  return (fakeHistory as any).createLocation(path); // Something is suspect with the typing for history and it was complaining that it doesn't exist but clearly does
}

/**
 * Given an absolute URL, return the relative portion of it.
 * @param  {String} url absolute url
 * @return {String}     relative portion of url.
 */
export function relativizeUrl(url: string) {
  const matches = ABSOLUTE_URL_RE.exec(url);
  if (matches) {
    const relativeUrl = url.substring(matches.index + matches[0]!.length);
    return relativeUrl === '' ? '/' : relativeUrl;
  } else {
    return url;
  }
}

export const toRelativeUrlString = ({ pathname, search = '', hash = '' }: { pathname: string; search?: string; hash?: string }) => `${pathname}${search}${hash}`;

export const queryParameterExists = (key: string, queryString = window.location.search) => new URLSearchParams(queryString).has(key);

export const getAbsoluteUrl = (relativePath: string, origin: string = window.location.origin) => `${origin}${relativePath}`;

export const stripQueryParams = (urlString: string, ...paramsToStrip: string[]) => appendQuery(urlString, paramsToStrip.reduce((acc, cur) => ({ ...acc, [cur]: null }), {}), { removeNull: true });
